var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPeriodTracking = function SvgPeriodTracking(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 75,
    viewBox: "0 0 81 75",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F7F2ED",
    d: "M27.825 9.342L30 8.02 24.284 0l-1.871 1.131C12.189 7.328 0 18.668 0 37.491c0 18.825 12.19 30.164 22.415 36.361L24.312 75l5.572-8.057-2.145-1.301c-11.184-6.8-17.596-17.062-17.596-28.15 0-11.058 6.445-21.32 17.682-28.15M58.585 1.131L56.714 0 51 8.02l2.173 1.322c11.238 6.83 17.683 17.09 17.683 28.15 0 11.09-6.415 21.35-17.597 28.15l-2.143 1.303L56.691 75l1.894-1.148C68.811 67.652 81 56.316 81 37.492c0-18.824-12.19-30.164-22.415-36.36"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F8D0C5",
    d: "M40.5 54C46.299 54 51 49.075 51 43c0-4.051-3.5-11.384-10.5-22C33.5 31.616 30 38.949 30 43c0 6.075 4.701 11 10.5 11z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPeriodTracking, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/period-tracking.223f900a.svg";
export { ForwardRef as ReactComponent };